import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';

import { ErrorHttpResponse, SuccessHttpResponse } from '../../../models/https';
import { TransactionDetail } from '../../../models/transactions/transaction.model';
import useHttps from '../../useHttps';

const useTransactionDetail = (reference?: string) => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState<TransactionDetail | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!reference) return;

    const onSuccess = ({ data }: SuccessHttpResponse<TransactionDetail>) => setDetail(data);
    const onError = (err: AxiosError<ErrorHttpResponse>) => {
      console.error(err?.response?.data?.message ?? 'Failed to load transaction');
    };

    request(
      { url: `api/v1/admin/transactions/${reference}`, method: 'get' },
      onSuccess,
      setLoading,
      onError
    );
    // eslint-disable-next-line
  }, [reference, reloadKey]);

  const refetch = () => setReloadKey((key) => key + 1);

  return { detail, loading, refetch };
};

export default useTransactionDetail;
